module.exports = __webpack_public_path__ + "static/media/fda.ec120d55.svg";